/**
 * Tenant feature item type values
 */
export enum TenantFeatureItemTypeEnum {
	PROMOTIONAL = 'promotional',
}
